<section class="main-section usercenter-section p-3">
  <header class="d-flex justify-content-between align-items-center main-heading">
    <div class="d-flex align-items-center">
      <a class="btn btn-link me-3 p-0 d-block d-xl-none" data-bs-toggle="offcanvas" href="#offcanvasExample"
        role="button" aria-controls="offcanvasExample">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 7H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
          <path d="M3 12H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
          <path d="M3 17H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
        </svg>
      </a>
      <h3 *ngIf="!openCreatePackage" class="heading-span  text-black">Notification</h3>
      <h3 *ngIf="openCreatePackage" class="heading-span  text-black">
        <span>Notification / </span> Create Package
      </h3>
    </div>

  </header>
  <div *ngIf="openCreatePackage" class="table-responsive tab-table p-0 mb-0">
    <app-package [openedFrom]="5" [selectedPackage]="packageToCreate" [isCurrentTab]="activeTab" [showForm]="showForm"
      (packageActionTriggered)="closeForm($event)" [notificationId]="notificationId" [packageType]="packageType">
    </app-package>
  </div>

  <div *ngIf="!openCreatePackage" class="bg-white d-flex justify-content-between align-items-center radius8 mb-3">
    <div class="tabs mb-0 w-100">
      <ul class="nav nav-tabs" style="margin-right: 25px;">
        <li class="nav-item">
          <button (click)="fetchNotifications(userEmail, NotificationViewMode.UnreadMessages)" class="nav-link active"
            id="active-user-tab" data-bs-toggle="tab" data-bs-target="#notification-messages-tab-pane" type="button"
            role="tab" aria-controls="notification-messages-tab-pane" aria-selected="false">
            <span>Unread</span>
          </button>
        </li>
        <li class="nav-item">
          <button (click)="fetchNotifications(userEmail, NotificationViewMode.ReadMessages)" class="nav-link"
            id="inactive-user-tab" data-bs-toggle="tab" data-bs-target="#notification-messages-tab-pane" type="button"
            role="tab" aria-controls="notification-messages-tab-pane" aria-selected="true">
            <span>Read</span>
          </button>
        </li>

        <li class="nav-item">
          <button (click)="fetchNotifications(userEmail, NotificationViewMode.Archived)" class="nav-link"
            id="inactive-user-tab" data-bs-toggle="tab" data-bs-target="#notification-messages-tab-pane" type="button"
            role="tab" aria-controls="notification-messages-tab-pane" aria-selected="true">
            <span>Archived</span>
          </button>
        </li>
        <li class="nav-item ms-auto">
          <button (click)="fetchNotificationSubscriptions(userEmail, true)" class="nav-link"
            id="notification-subscription-tab" data-bs-toggle="tab" data-bs-target="#notification-subscription-tab-pane"
            type="button" role="tab" aria-controls="notification-subscription-tab-pane" aria-selected="false"
            style="background-color: transparent;">

            <mat-icon style="vertical-align:text-top;font-size: 1.5em;"  matTooltipPosition="middle">settings</mat-icon>
            <span>Subscriptions</span>

          </button>
        </li>
      </ul>
    </div>
  </div>
  <div class="container-fluid">
  <div class="row canvas" *ngIf="!openCreatePackage">

    <fieldset *ngIf="viewMode==NotificationViewMode.ReadMessages||viewMode==NotificationViewMode.UnreadMessages||viewMode==NotificationViewMode.Archived" style="padding: 1em;" class="col-md-3 bg-white mb-2 px-3 pb-0 mx-0 bg-white radius8 ">
      <legend style="font-size: smaller;" class="form-label">Subject Filters</legend>
      <mat-button-toggle-group style="font-size: smaller;margin-bottom: 2em;"
        name="notificationTypes" aria-label="Notification Types" multiple vertical>
        @if (isLoading) {
          <mat-button-toggle [disabled]="true" class="notification-type-options">
            <mat-icon>hourglass_empty</mat-icon>
            <span class="button-text">Loading...</span>
          </mat-button-toggle>
        }
        <mat-button-toggle *ngFor="let notificationType of notificationTypes"
          [disabled]="notificationType.notificationCount==0 && !notificationType.isFiltered"
          [checked]="notificationType.isFiltered" 
          (change)="notificationType.isFiltered = $event.source.checked;filterNotifications()"
          [value]="notificationType.notificationTypeId"
          title="{{notificationType.notificationTypeName}}" 
          
          class="notification-type-options">
          <span class="button-text">
            {{notificationType.notificationTypeName}}
            <span disabled style="position: absolute;top:2px;right: 2px;"
              [hidden]="notificationType.notificationCount==0"
              class="badge badge-secondary">&nbsp;{{notificationType.notificationCount}}&nbsp;</span>
          </span>

        </mat-button-toggle>
      </mat-button-toggle-group>
    </fieldset>
    <div class="notification-wrapper"
    [class.col-md-12]="viewMode == NotificationViewMode.DataAlerts"
  [class.col-md-9]="viewMode != NotificationViewMode.DataAlerts"
    >
      <div class="tab-content">
        <div class="tab-pane fade show active" id="notification-messages-tab-pane" role="tabpanel">
          @if (viewMode==NotificationViewMode.ReadMessages || viewMode==NotificationViewMode.UnreadMessages ||
          viewMode==NotificationViewMode.Archived) {
          <div *ngFor="let notification of filteredNotifications" class="mb-2 px-3 pb-0 mx-0 bg-white radius8 ">
            <div class="d-flex border-bottom-gray py-4  row">
              <div class="col-md-1">
                @if(notification.notificationTypeId == notificationType.SystemNotification){
                    <mat-icon color="primary">campaign</mat-icon>
                }
                @else if (notification.notificationTypeId == notificationType.DataAlert) {
                    <mat-icon color="primary">notifications_active</mat-icon>
                }
                @else{
                  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path opacity="0.4"
                      d="M12 22.0098C17.5228 22.0098 22 17.5326 22 12.0098C22 6.48692 17.5228 2.00977 12 2.00977C6.47715 2.00977 2 6.48692 2 12.0098C2 17.5326 6.47715 22.0098 12 22.0098Z"
                      fill="#4F6681" />
                    <path
                      d="M12 6.93945C9.93 6.93945 8.25 8.61945 8.25 10.6895C8.25 12.7195 9.84 14.3695 11.95 14.4295C11.98 14.4295 12.02 14.4295 12.04 14.4295C12.06 14.4295 12.09 14.4295 12.11 14.4295C12.12 14.4295 12.13 14.4295 12.13 14.4295C14.15 14.3595 15.74 12.7195 15.75 10.6895C15.75 8.61945 14.07 6.93945 12 6.93945Z"
                      fill="#4F6681" />
                    <path
                      d="M18.7797 19.3602C16.9997 21.0002 14.6197 22.0102 11.9997 22.0102C9.37973 22.0102 6.99973 21.0002 5.21973 19.3602C5.45973 18.4502 6.10973 17.6202 7.05973 16.9802C9.78973 15.1602 14.2297 15.1602 16.9397 16.9802C17.8997 17.6202 18.5397 18.4502 18.7797 19.3602Z"
                      fill="#4F6681" />
                  </svg>
                }
              </div>

              <div class="col-md-8" *ngIf="notification.status==null">
                <div class="px-2 my-auto">
                  <p class="px-2 mb-0" [innerHTML]="notification.message"></p>
                  <p class="px-2 mb-0" [innerHTML]="notification.createdOn | date : 'dd/MM/yyyy HH:mm:ss'"></p>
                </div>
              </div>
              <div class="col-md-8" *ngIf="notification.status!=null">
                <div *ngIf="notification.notificationTypeId == notificationType.SystemNotification" class="px-2 my-auto">
                  <p class="px-2 mb-0" [innerHTML]="notification.message"></p>
                  <p class="px-2 mb-0" [innerHTML]="notification.createdOn | date : 'dd/MM/yyyy'"></p>
                </div>
                <div *ngIf="notification.notificationTypeId == notificationType.DataAlert" class="px-2 my-auto">
                  <p class="px-2 mb-0" [innerHTML]="notification.message"></p>
                  <p class="px-2 mb-0" [innerHTML]="notification.createdOn | date : 'dd/MM/yyyy'"></p>
                </div>

                <div *ngIf="notification.notificationTypeId == notificationType.SwappedAPackage" class="px-2 my-auto">
                  <p class="px-2 mb-0" [innerHTML]="notification.message"></p>
                  <p class="px-2 mb-0" [innerHTML]="notification.createdOn | date : 'dd/MM/yyyy HH:mm:ss'"></p>
                </div>
                <div *ngIf="notification.notificationTypeId == notificationType.RequestToUpgrade" class="px-2 my-auto">
                  <p class="px-2 mb-0" [innerHTML]="notification.message"></p>
                  <p class="px-2 mb-0" [innerHTML]="notification.createdOn | date : 'dd/MM/yyyy HH:mm:ss'"></p>
                  <div *ngIf="!notification.isProcessed" class="text-start mt-sm-3 px-2">
                    <button type="button" class="btn theme-btn cursor-pointer px-5"
                      (click)="acceptRequest(notification)">
                      Accept
                    </button>
                    <button type="button" class="btn theme-btn-outline px-5 notify-decline-btn cursor-pointer"
                      (click)="declineRequest(notification)">
                      Decline
                    </button>
                  </div>
                </div>
                <div *ngIf="notification.notificationTypeId == notificationType.RequestAccessToViewModuleAndSubcategory"
                  class="px-2 my-auto">
                  <p class="px-2 mb-0" [innerHTML]="notification.message"></p>
                  <p class="px-2 mb-0" [innerHTML]="notification.createdOn | date : 'dd/MM/yyyy HH:mm:ss'"></p>
                  <div *ngIf="!notification.isProcessed" class="text-start mt-sm-3 px-2">
                    <button type="button" class="btn theme-btn cursor-pointer px-5" (click)="grantAccess(notification)">
                      Grant Access
                    </button>
                    <button type="button" class="btn theme-btn-outline px-5 notify-decline-btn cursor-pointer"
                      (click)="declineAccess(notification)">
                      Decline Access
                    </button>
                  </div>
                </div>
                <div *ngIf="notification.notificationTypeId == notificationType.AddSchoolAfterTransfer"
                  class="px-2 my-auto">
                  <p class="px-2 mb-0" [innerHTML]="notification.message"></p>
                  <p class="px-2 mb-0" [innerHTML]="notification.createdOn | date : 'dd/MM/yyyy HH:mm:ss'"></p>
                  <div *ngIf="!notification.isProcessed" class="text-start mt-sm-3 px-2">
                    <button type="button" class="btn theme-btn cursor-pointer px-5"
                      (click)="transferSchool(notification)">
                      Add School
                    </button>
                  </div>
                </div>
                <div *ngIf="notification.notificationTypeId == notificationType.DeleteSchoolAfterTransfer"
                  class="px-2 my-auto">
                  <p class="px-2 mb-0" [innerHTML]="notification.message"></p>
                  <p class="px-2 mb-0" [innerHTML]="notification.createdOn | date : 'dd/MM/yyyy HH:mm:ss'"></p>
                  <div *ngIf="!notification.isProcessed" class="text-start mt-sm-3 px-2">
                    <button type="button" class="btn theme-btn cursor-pointer px-5"
                      (click)="transferSchool(notification)">
                      Delete School
                    </button>
                  </div>
                </div>
                <div
                  *ngIf="notification.notificationTypeId == notificationType.RequestToUpgradeWithCustomization || notification.notificationTypeId == notificationType.RequestToCreateNewPackage"
                  class="px-2 my-auto">
                  <p class="px-2 mb-0" [innerHTML]="notification.message"></p>
                  <p class="px-2 mb-0" [innerHTML]="notification.createdOn | date : 'dd/MM/yyyy HH:mm:ss'"></p>
                  <div *ngIf="!notification.isProcessed" class="text-start mt-sm-3 px-2">
                    <button (click)="createNewPackage(notification)" type="button" class="btn theme-btn cursor-pointer">
                      Create New package
                    </button>
                    <button type="button" class="btn theme-btn-outline px-5 notify-decline-btn cursor-pointer"
                      (click)="declineRequest(notification)">
                      Decline
                    </button>
                  </div>
                </div>
              </div>
              <div *ngIf="viewMode==NotificationViewMode.ReadMessages" class="col-md-2">
               @if(
               ((notification.notificationTypeId != notificationType.DataAlert)))
               {
                <button type="button" class="btn theme-btn-outline notify-decline-btn cursor-pointer"
                    (click)="archive_notification_message(notification.notificationId)">
                    <mat-icon>archive</mat-icon>&nbsp;Archive
                  </button>
                }
              </div>
            </div>
          </div>
          <div *ngIf="!filteredNotifications.length" class="noDataFound">
            <h1 class="no-data-found-heading">{{'No Notifications Found'}}</h1>
          </div>
          }
        </div>

        <div class="tab-pane fade" id="notification-subscription-tab-pane" role="tabpanel"
          aria-labelledby="notification-subscription-tab">
            <app-data-alerts *ngIf="viewMode == NotificationViewMode.DataAlerts"></app-data-alerts>
        </div>
      </div>



    </div>
  </div></div>
</section>